import { createSystem, defineConfig, defaultConfig } from '@chakra-ui/react';

import { alertRecipe } from './alert.recipe';
import { avatarSlotRecipe } from './avatar.recipe';
import { buttonRecipe } from './button.recipe';
import { checkboxSlotRecipe } from './checkbox.recipe';
import { colors, colorTokens } from './colors';
import { fieldSlotRecipe } from './field.recipe';
import { formLabelRecipe } from './form-label.recipe';
import globalStyles from './global-styles';
import { headingRecipe } from './heading.recipe';
import { iconRecipe } from './icon.recipe';
import { inputRecipe } from './input.recipe';
import { linkRecipe } from './link.recipe';
import { menuSlotRecipe } from './menu.recipe';
import { radioGroupSlotRecipe } from './radio-group.recipe';
import { selectRecipe } from './select.recipe';
import { spinnerRecipe } from './spinner.recipe';
import { tableSlotRecipe } from './table.recipe';
import { tabsSlotRecipe } from './tabs.recipe';
import { tagSlotRecipe } from './tag.recipe';
import { textRecipe } from './text.recipe';
import { toastSlotRecipe } from './toast.recipe';

const config = defineConfig({
  globalCss: globalStyles,
  theme: {
    recipes: {
      alert: alertRecipe,
      button: buttonRecipe,
      formLabel: formLabelRecipe,
      heading: headingRecipe,
      icon: iconRecipe,
      link: linkRecipe,
      select: selectRecipe,
      spinner: spinnerRecipe,
      text: textRecipe,
      input: inputRecipe,
    },
    slotRecipes: {
      checkbox: checkboxSlotRecipe,
      avatar: avatarSlotRecipe,
      field: fieldSlotRecipe,
      menu: menuSlotRecipe,
      table: tableSlotRecipe,
      tabs: tabsSlotRecipe,
      tag: tagSlotRecipe,
      toast: toastSlotRecipe,
      radioGroup: radioGroupSlotRecipe,
    },
    tokens: {
      colors,
      fonts: {
        body: { value: '"Poppins", "Helvetica", sans-serif' },
        heading: { value: '"Poppins", "Helvetica", sans-serif' },
      },
    },
    keyframes: {
      navDotPulse: {
        from: { transform: 'scale(1)' },
        to: { transform: 'scale(1.3)' },
      },
    },
    semanticTokens: {
      colors: colorTokens,
    },
  },
  preflight: true,
});

export const system = createSystem(defaultConfig, config);

export default system;
